
<!-- Built in paginator -->
<markdown class="mt-0">
  This grid uses the built-in paginator. Note slowness with large datasets. Also, if you go to the last page, then the previous page, it messes up and shows blank rows.
</markdown>
<ui-grid
  [readEndpoint]="'mock/StarWarsActors'"
  [pageSizes]="[5, 10, 20]"
  [agGridOptions]="{paginationPageSize:10}"
  [panelHeaderConfig]="agPanelHeaderConfig"
  [showPanelHeader]="true"

  [useOldBustedAgPaginatorInsteadOfTheNewCoolEzPaginator]="true"
  [showOldAgPaginationPanel]="true"
/>

<!-- EZ paginator -->
 <markdown class="mt-0">
  This grid uses the new EZ paginator. It's quicker and doesn't mess up the next-to-last page. Also, there's an option to insert blank rows on the last page
  so the grid doesn't change size. This is completely optional.
</markdown>
<ui-grid
  [readEndpoint]="'mock/StarWarsActors'"
  [pageSizes]="[5, 10, 20]"
  [agGridOptions]="{paginationPageSize:10}"
  [panelHeaderConfig]="ezPanelHeaderConfig"
  [showPanelHeader]="true"

  [(additionalActionsFormValues)]="ezAdditionActionFormValues"
  [showBlankRowsOnLastPage]="ezAdditionActionFormValues['blankRows']"
/>

<!-- EZ paginator client side -->
<markdown class="mt-0">
  The above two grids use server-side paging with large datasets. The grids below are completely client side, they will download all the rows regardless of the page or page size.
</markdown>
<ui-grid
  [readEndpoint]="'mock/StarWarsActors'"
  [pageSizes]="[5, 10, 20]"
  [agGridOptions]="{paginationPageSize:5}"
  [panelHeaderConfig]="clientAgPanelHeaderConfig"
  [showPanelHeader]="true"

  [useOldBustedAgPaginatorInsteadOfTheNewCoolEzPaginator]="true"
  [showOldAgPaginationPanel]="true"
/>

<!-- EZ paginator client side -->
  <markdown class="mt-0">
  Client size EZ Paginator
</markdown>
<ui-grid
  [readEndpoint]="'mock/StarWarsActors'"
  [pageSizes]="[5, 10, 20]"
  [agGridOptions]="{paginationPageSize:5}"
  [panelHeaderConfig]="clientEzPanelHeaderConfig"
  [showPanelHeader]="true"
/>


